import { useEffect, useRef, useState } from 'react';

export const usePrevious = (value, defaultValue) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  const defaultReturnValue = defaultValue !== undefined ? defaultValue : value;
  return ref.current === undefined || ref.current === null
    ? defaultReturnValue
    : ref.current;
};

export const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(
    () => {
      savedCallback.current = callback;
    },
    [callback],
  );

  // Set up the interval.
  useEffect(
    // eslint-disable-next-line consistent-return
    () => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        const id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    },
    [delay],
  );
};

export const useWindowWidth = () => {
  const [width, setWidth] = useState(() => window.innerWidth);
  function handleChangeResize() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleChangeResize);
    return () => {
      window.removeEventListener('resize', handleChangeResize);
    };
  }, []);

  return width;
};



// WEBPACK FOOTER //
// ./foody/src/hooks/commonHooks.js